module.exports = __webpack_public_path__ + "static/img/6.a6b2971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/02/6.png
// module id = c14X
// module chunks = 1